import ReactDOM from 'react-dom/client';
import '@styles/index.css';
import '@shared/styles/index.css';
import "@shared/styles/variables.css";
import './shared/globals';
import App from './App';
import {BrowserRouter} from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  // </React.StrictMode>
);
